import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExcelExportService, FilterService, GridComponent, PdfExportService, SelectionSettingsModel, ToolbarItems, ToolbarService, VirtualScrollService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { DialogComponent, Tooltip, TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { DataUtil } from '@syncfusion/ej2-data';
import { ToastrService } from 'ngx-toastr';
import { Subscription, interval } from 'rxjs';
import { IServerSettings } from '../../../shared/models/index';
import { SettingsService } from '../../../shared/services/settings.service';
import { NgbTooltipConfig, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { GridPreferencesService } from '../../../shared/services/grid-preferences.service';
import { FileUploadService } from '../../../shared/services/file-upload.service';
import { SplUploadFileStatus } from '../../../shared/models/spl-upload-file-status';
import { PragmaticValidationStatus } from '../../../shared/models/pragmatic-validation-status';
import { OrderService } from '../../../shared/services';
import { IFileIngestionHistory } from '../../../shared/models/file-upload-history.model';

@Component({
  selector: 'app-fileuploadhistorygrid',
  templateUrl: './fileuploadhistorygrid.component.html',
  styleUrls: ['./fileuploadhistorygrid.component.scss'],
  providers: [FilterService, VirtualScrollService, ToolbarService, ExcelExportService, PdfExportService, NgbTooltipModule, NgbTooltipConfig],
  encapsulation: ViewEncapsulation.Emulated
})
export class FileUploadHistoryGridComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {

  @ViewChild('historyGrid', { static: true })
  public historyGrid: GridComponent;

  @ViewChild('tooltipObj', { static: true }) tooltipObj: TooltipComponent;

  @ViewChild('copiedTextDialog', { static: true })
  public copiedTextDialog: DialogComponent;

  @ViewChild('tooltip', { static: false })
  public tooltipControl: TooltipComponent;
  public splUploadFileStatus: typeof SplUploadFileStatus = SplUploadFileStatus;
  public pragmaticValidationStatus: typeof PragmaticValidationStatus = PragmaticValidationStatus;
  public toolbar: ToolbarItems[] = [];
  public data: IFileIngestionHistory[];
  public dateFormat: Object;
  public customerId: string;
  public fileCount: string;
  public selectedFileCount: number = 0;
  public ordersGridToolbarOptions: Object;
  error: string;
  pageOptions: Object;
  gridComplete = false;
  settings: IServerSettings;
  copiedToClipboard = '';
  selectedFileName: any;
  tooltipContent: HTMLElement = document.createElement('div');
  public selectionOptions?: SelectionSettingsModel;
  @Input() gridData: string;
  @Input() appDefaults: any;
  @Output() messageEvent = new EventEmitter<string>();
  dateRangeDataSource = ['90 days', '180 days', '1 Year', '2 Years', 'All'];
  selectedDateRangeFilter = '1 Year';
  disabledColumns: string[] = ['File ID', 'File Name'];
  initial = true;
  scrollSettings: { width: string; height: number; enableColumnScrolling: boolean; enableRowScrolling: boolean; };
  needsToPoll: boolean = true;
  loading: boolean = true;
  selectedRowIndexes: number[] = [];

  tooltipCol: Tooltip = new Tooltip({
    content: this.tooltipContent,
    cssClass: 'customtooltip',
    enableHtmlParse: false
  });
  sub: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private settingsService: SettingsService,
    private toastr: ToastrService,
    tooltipConfig: NgbTooltipConfig,
    public gridPreferencesService: GridPreferencesService,
    private orderService: OrderService,
    private fileUploadService: FileUploadService) {
    this.settings = this.settingsService.getSettings();
    tooltipConfig.placement = 'bottom-left';
    tooltipConfig.autoClose = true;
  }

  ngAfterViewInit(): void {
    this.createCustomToolbarItems();
  }

  dateRangeSelectionChanged(dateRangeLimitValue: string) {
    this.selectedDateRangeFilter = dateRangeLimitValue;
    this.getFileHistoryDashboard();
}

  openTooltip(tooltip, contents: string) {

    tooltip.close();
    tooltip.open({ contents });
  }

  closeTooltip(tooltip) {
    tooltip.close();
  }

 async keydownEnter(e, data) {
   const type = e.type;

   this.copiedToClipboard = data;

   if (type === 'keydown' && (e.which === 13 || e.keyCode === 13)) {

     if (navigator.clipboard) {
       navigator.clipboard.writeText(data)
         .then(
           () => e.target.closest('.e-templatecell').focus()
         );
     }
    }
  }
  createCustomToolbarItems(){
    let toolbarItems = [];

    toolbarItems.push('ColumnChooser');

    this.ordersGridToolbarOptions = toolbarItems;
  }

  tooltipContents(data) {

   return data;
  }


  hideSFToolTip(args) {

    this.tooltipControl = (args.target as any).parentElement?.ej2_instances[0];

    if (this.tooltipControl) {
      this.tooltipControl.content = '';
      this.tooltipControl.close();
    }
  }

  tooltipValue(args) {
    // here you can get the row data of the target cell
    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {
      const rowInfo = this.historyGrid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      this.tooltipObj.content = rowData[(rowInfo.column as any).field];
      this.tooltipObj.width = `${ args.target.scrollWidth }px`;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const gridData: SimpleChange = changes.gridData;
    if (gridData && gridData.currentValue) {
      this.data = this.mapData(DataUtil.parse.parseJson(gridData.currentValue));
    } else {
      this.error = 'External error';
    }
  }

  ngOnInit(): void {
    this.dateFormat = { type: 'dateTime', format: 'MM/dd/yyyy hh:mm a' };
    this.appDefaults = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100, 'All'] };
    this.selectionOptions = { mode: 'Row', type: 'Multiple' };
    let data = this.activatedRoute.snapshot.data['splUploadData'];
    this.data = data[0]?.data;
    this.data = this.mapData(data[0]?.data);
    this.pollData();
  }

  mapData(data: any[]): any[] {
    return data.map(item => ({
      ...item,
      fileStatusText: this.getFileStatusText(item.fileStatus)
    }));
  }

  toolbarClick(args: ClickEventArgs): void {
     if (!this.selectedFileName && args.item.id !== 'grid_columnchooser') {
      this.toastr.warning(`No Row(s) selected.`, '', { closeButton: true });
      return;
    }
  }

  viewFormOrGoToDashboard(llRevisionId: string, isDraftMode: boolean) {
    if (llRevisionId) {
      const url = isDraftMode ? '/products/ll-form' : '/products/dashboard';
      this.router.navigate([url, llRevisionId]);
    }
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  recordDoubleClickRow(args) { }

  complete(args: any) {
    switch (args.requestType) {
      case 'filterafteropen':

        if (args.columnType === 'date') {
          args.filterModel.dlgDiv.querySelector(
            '.e-datepicker'
          ).ej2_instances[0].format = 'MM/dd/y';
        }
        break;
      case 'filtering':

        if (this.historyGrid && this.historyGrid.columns && this.historyGrid.columns.length > 0) {
          const pageCountMsg = document.getElementsByClassName('e-pagecountmsg')[0];

          if (pageCountMsg) {
            const pageItemCounter = (pageCountMsg as any).innerText;

            this.fileCount = pageItemCounter.substr(pageItemCounter.indexOf('(') + 1, pageItemCounter.indexOf(' item') - 1);
          } else {
            this.fileCount = '0';
          }
          this.messageEvent.emit(this.fileCount);
        }
        break;
    }
  }

  formatVersionNumber(versionNumber: string): string {
    if (versionNumber && !versionNumber.includes('.')) {
      return versionNumber + '.0';
    }
    return versionNumber;
  }

  pollData() {
    this.sub = interval(60000).subscribe(() => {
      if (this.needsToPoll) {
        this.getFileHistoryDashboard();
      }
    });
  }

  getFileHistoryDashboard() {
    this.loading = true;
      this.fileUploadService.fetchUploadedFileHistory(this.selectedDateRangeFilter).subscribe({
        next: (result : any) => {
          if(result) {
            this.selectedRowIndexes = this.historyGrid.getSelectedRowIndexes();
            this.processDashboardData(result.data);
            this.historyGrid.refresh();
          }
          else{
           this.loading = false
          }
        }
      });

  }

  checkBoxChange(event) {
    this.selectedFileCount = this.historyGrid.getSelectedRecords().length;
  }

  dataBound(args): void {
    if (this.selectedRowIndexes.length) {
      this.historyGrid.selectRows(this.selectedRowIndexes);
    }
  }

  // Download pragmatic validation file
  downloadFile(filePath, fileName) {
    this.orderService.downloadFile(filePath, fileName).subscribe(response => {
      this.orderService.postDownloadFile(response, fileName);
    },
    error => {
      this.toastr.error(error.message);
    });
  }

  downloadLogFile(fileId: number, fileName: string) {
    let txtFileName = `log_${fileName?.replace('.zip', '')}.txt`
    this.sub = this.fileUploadService.downloadUploadedFileHistoryLog(fileId, txtFileName).subscribe({
      next: response => {
        // non-IE
        const URL = window.URL || (<any>window).webkitURL;
        const downloadUrl = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = txtFileName;
        link.click();
      },
      error: error => {
        this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
      }
    });
  }

  rowSelecting(args) {
    this.selectedFileCount = this.historyGrid.getSelectedRecords().length;
  }

  processDashboardData(data: IFileIngestionHistory[]) {
    const today: Date = new Date();
    const numberOfDaysAgo: Date = new Date(today.getTime() - parseInt(this.settingsService.splHistoryDashBoardAutoRefreshDays, 10) * 24 * 60 * 60 * 1000);

    for(let i = 0; i < data.length; i++){
      data[i].uploadedDate = new Date(data[i].uploadedDate);
    }

    this.data = this.mapData(data);
    const filteredDataTaskStatusInProgress = this.data.filter(item => item.fileStatus === 2 || item.fileStatus == 1);
    this.loading = false;
    const filteredDataWithConfigDaysAgo = filteredDataTaskStatusInProgress.some(item => {
      const createDate: Date = new Date(item.uploadedDate);
      return createDate >= numberOfDaysAgo;
    });

    if (!filteredDataWithConfigDaysAgo) {
      this.needsToPoll = false;
    }
  }

  removedToasterWarning(): void {
     this.toastr.warning(`This product has been deleted and does not exist anymore!`, '', { closeButton: true });
 }

  getFileStatusText(status: SplUploadFileStatus): string {
    switch (status) {
      case this.splUploadFileStatus.Passed:
        return 'Passed';
      case this.splUploadFileStatus.Failed:
        return 'Failed';
      case this.splUploadFileStatus.Received:
        return 'Received';
      case this.splUploadFileStatus.InProcess:
        return 'In Process';
      default:
        return '';
    }
  }
}

